__turbopack_context__.v({
  "form": "kwk-form-module-scss-module__0iRdGW__form",
  "li": "kwk-form-module-scss-module__0iRdGW__li",
  "placeholder": "kwk-form-module-scss-module__0iRdGW__placeholder",
  "ul": "kwk-form-module-scss-module__0iRdGW__ul",
});
